<template>
  <div class="key-value-data-view">
    <header v-if="title" class="key-value-data-view__title">{{ title }}</header>

    <table class="key-value-data-view__table">
      <tr v-for="item in items" :key="item[keyProp]">
        <td class="key-value-data-view__name">{{ item[nameProp] }}</td>
        <td class="key-value-data-view__value">{{ item[valueProp] }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'KeyValueDataView',

  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    keyProp: {
      type: String,
      default: 'name',
    },
    nameProp: {
      type: String,
      default: 'name',
    },
    valueProp: {
      type: String,
      default: 'value',
    },
  },
};
</script>

<style lang="scss">
.key-value-data-view {
  margin-bottom: $global-margin;

  &__title {
    font-size: 110%;
    font-weight: 500;
    margin-bottom: $global-margin/2;
  }

  &__name {
    padding: $global-padding/2 0;
    min-width: 150px;
    color: $asbestos;
  }

  &__value {
    color: $wet-asphalt;
    font-weight: 400;
  }
}
</style>
